import React from 'react';
import { Clock, Loader2, CheckCircle2, AlertCircle } from 'lucide-react';

const STATUS_MAP = {
  queued: { cls: 'bg-slate-100 text-slate-600', label: 'Queued', Icon: Clock },
  extracting: { cls: 'bg-amber-100 text-amber-700', label: 'Extracting…', Icon: Loader2, spin: true },
  chunking: { cls: 'bg-amber-100 text-amber-700', label: 'Chunking…', Icon: Loader2, spin: true },
  embedding: { cls: 'bg-amber-100 text-amber-700', label: 'Embedding…', Icon: Loader2, spin: true },
  ready: { cls: 'bg-emerald-100 text-emerald-700', label: 'Ready', Icon: CheckCircle2 },
  failed: { cls: 'bg-red-100 text-red-700', label: 'Failed', Icon: AlertCircle },
};

const StatusBadge = ({ status, error }) => {
  const s = STATUS_MAP[status] || STATUS_MAP.queued;
  return (
    <span title={error || ''} className={`text-[11px] font-medium px-2 py-0.5 rounded-full inline-flex items-center gap-1 ${s.cls}`}>
      <s.Icon className={`w-3 h-3 ${s.spin ? 'animate-spin' : ''}`} />
      {s.label}
    </span>
  );
};

export default StatusBadge;
